import React, { FC, useEffect } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { Layout } from 'antd';
import { EmployeesPage } from '../webux-pages/employees/EmployeesPage';
import './WebUxLayout.less';
import GoalsPage from '../webux-pages/goals/GoalsPage';
import EnumX from '../../enum/EnumX';
import Designation from '../../designation/Designation';
import Profile from '../../profile/Profile';
import PerformanceCyclePage from '../../performanceCycle/PerformanceCyclePage';
import { TeamsPage2 } from '../webux-pages/teams/TeamsPage2';
import Configuration from '../../configuration/Configuration';
import EmailTemplate from '../../emailTemplate/EmailTemplate';
import { MyGoals } from '../webux-pages/my-goals/MyGoals';
import GoalView from '../webux-pages/goals/GoalsView';
import ReviewQuestions from '../webux-pages/review-settings/reviewQuestions';
import { ReviewQuestionSets } from '../webux-pages/review-settings/reviewQuestionSets';
import PeerReviews from '../webux-pages/peer-reviews/PeerReviews';
import { SetupPage } from '../webux-pages/setup/Setup';
import { TeamSetupPage } from '../webux-pages/setup/teamSetup/TeamSetup';
import InternalCustomer from '../webux-pages/internalCustomers/InternalCustomers';
import InternalCustomerAnswers from '../webux-pages/internalCustomerAnswers/internalCustomerAnswers';
import PeerReviewsApprove from '../webux-pages/peer-reviews-approve/PeerReviewsApprove';
import { useUserInfo } from '../../../connection/Application';
import { UserGroupSets } from '../webux-pages/UserGroup/UserGroupSets';
import { UserGroup } from '../webux-pages/UserGroup/UserGroup';
import { MainPerformanceResultsPage } from '../webux-pages/PerformanceResults/MainPerformanceResultsPage';
import { UserPerformanceResultsPage } from '../webux-pages/employees/UserPerformanceResultsPage';
import UserPeerReviews from '../webux-pages/employees/UserPeerReviews';
import UserInternalCustomerAnswers from '../webux-pages/employees/UserInternalCustomerAnswers';
import { UserTeamTimeLine } from '../webux-pages/employees/UserTeamTimeLine';
import { AllUserPerformancePage } from '../webux-pages/PerformanceResults/AllUserPerformancePage';
import { PerformanceResultsPage } from '../webux-pages/PerformanceResults/PerformanceResultsPage';
import SinglePeerReviewsApprove from '../webux-pages/peer-reviews-approve/SinglePeerReviewsApprove';
import { AllUserFeedBack } from '../webux-pages/PerformanceResults/AllUserUserFeedBack';
import { msalInstance } from '../../../index';
import GoalsExportPage from '../webux-pages/goals/GoalsExportPage';

const { Content } = Layout;

const GuardedRoute: FC<any> = ({
  component: Component,
  authRoles,
  userRoles,
  redirectPath,
  ...rest
}) => {
  return (
    <Route
      {...rest}
      render={(props) =>
        authRoles?.filter((e: string) => userRoles?.findIndex((e1: string) => e1 === e) !== -1)
          .length !== 0 ? (
          <Component {...props} />
        ) : (
          <Redirect to={redirectPath} />
        )
      }
    />
  );
};

export const WebUxContent: FC = () => {
  const user = useUserInfo();
  useEffect(() => {
    msalInstance
      .handleRedirectPromise()
      .then((response) => {
        if (response) {
          console.log('Redirect response:', response);
          msalInstance.setActiveAccount(response.account);
        }
      })
      .catch((error) => {
        console.error('Error handling redirect:', error);
      });
  }, []);
  return (
    <Content className="webux-content">
      <Switch>
        <Route path="/webux/dashboard/:employeeId" component={PerformanceResultsPage} />
        <Route path="/webux/dashboard" component={MainPerformanceResultsPage} />
        {user?.roles?.includes('admin') || user?.roles?.includes('hr') ? (
          <GuardedRoute
            path="/webux/performance-result/employee/:id?"
            component={UserPerformanceResultsPage}
            authRoles={['hr', 'admin']}
            userRoles={user?.roles}
            redirectPath={'/webux/my-goals'}
          />
        ) : (
          <Route
            path="/webux/performance-result/employee/:employeeId"
            component={PerformanceResultsPage}
          />
        )}

        {/*<GuardedRoute*/}
        {/*  path="/webux/performance-result"*/}
        {/*  component={AllUserPerformancePage}*/}
        {/*  authRoles={['hr', 'admin']}*/}
        {/*  userRoles={user?.roles}*/}
        {/*  redirectPath={'/webux/my-goals'}*/}
        {/*/>*/}
        <Route path="/webux/performance-result/employees" component={AllUserPerformancePage} />
        <GuardedRoute
          path="/webux/performance-result/user-feedback"
          component={AllUserFeedBack}
          authRoles={['hr', 'admin', 'user']}
          userRoles={user?.roles}
          redirectPath={'/webux/my-goals'}
        />
        <Route path="/webux/performance-result/goals" component={GoalsExportPage} />
        <GuardedRoute
          path="/webux/employees/:id?/performance-result"
          component={UserPerformanceResultsPage}
          authRoles={['hr', 'admin']}
          userRoles={user?.roles}
          redirectPath={'/webux/my-goals'}
        />
        <GuardedRoute
          path="/webux/employees/goals/:type?/:id?/:name?/:oid?/:tid?"
          component={GoalsPage}
          authRoles={['hr', 'admin']}
          userRoles={user?.roles}
          redirectPath={'/webux/my-goals'}
        />
        <GuardedRoute
          path="/webux/employees/:id?/:name?/peer-reviews"
          component={UserPeerReviews}
          authRoles={['hr', 'admin']}
          userRoles={user?.roles}
          redirectPath={'/webux/my-goals'}
        />
        <GuardedRoute
          path="/webux/employees/:id?/:name?/internal-customers"
          component={UserInternalCustomerAnswers}
          authRoles={['hr', 'admin']}
          userRoles={user?.roles}
          redirectPath={'/webux/my-goals'}
        />
        <GuardedRoute
          path="/webux/employees/:id?/:name?/time-line"
          component={UserTeamTimeLine}
          authRoles={['hr', 'admin']}
          userRoles={user?.roles}
          redirectPath={'/webux/my-goals'}
        />
        <GuardedRoute
          path="/webux/employees"
          component={EmployeesPage}
          authRoles={['hr', 'admin']}
          userRoles={user?.roles}
          redirectPath={'/webux/my-goals'}
        />
        {/*<GuardedRoute*/}
        {/*  path="/webux/teams"*/}
        {/*  component={TeamsPage2}*/}
        {/*  authRoles={['hr', 'admin']}*/}
        {/*  userRoles={user?.roles}*/}
        {/*  redirectPath={'/webux/my-goals'}*/}
        {/*/>*/}
        <Route path="/webux/teams" component={TeamsPage2} />
        <Route path="/webux/my-goals/goals/:type?/:id?/:name?/:oid?/:tid?" component={GoalsPage} />
        <Route path="/webux/parent-goal/:cycle?/:id?/:name/view" component={GoalView} />
        <Route path="/webux/my-goals" component={MyGoals} />
        <Route path="/webux/profile" component={Profile} />
        <Route path="/webux/peer-reviews" component={PeerReviews} />
        <Route
          path="/webux/peer-reviews-approve/:user/:name"
          component={SinglePeerReviewsApprove}
        />
        <Route path="/webux/peer-reviews-approve" component={PeerReviewsApprove} />
        <Route path="/webux/internal-customers" component={InternalCustomer} />
        <Route path="/webux/internal-customer-answers" component={InternalCustomerAnswers} />
        <GuardedRoute
          path="/webux/criteria"
          component={ReviewQuestions}
          authRoles={['hr', 'admin']}
          userRoles={user?.roles}
          redirectPath={'/webux/my-goals'}
        />
        <GuardedRoute
          path="/webux/criteria-set"
          component={ReviewQuestionSets}
          authRoles={['hr', 'admin']}
          userRoles={user?.roles}
          redirectPath={'/webux/my-goals'}
        />
        <GuardedRoute
          path="/webux/internal-customer-answers"
          component={InternalCustomerAnswers}
          authRoles={['hr', 'admin']}
          userRoles={user?.roles}
          redirectPath={'/webux/my-goals'}
        />
        {/*goals/selection*/}
        <GuardedRoute
          path="/webux/performance-cycle"
          component={PerformanceCyclePage}
          authRoles={['hr', 'admin']}
          userRoles={user?.roles}
          redirectPath={'/webux/my-goals'}
        />
        <GuardedRoute
          path="/webux/setup/team-setup/:id?/:name"
          component={TeamSetupPage}
          authRoles={['hr', 'admin', 'user', 'manger']}
          userRoles={user?.roles}
          redirectPath={'/webux/my-goals'}
        />
        <GuardedRoute
          path="/webux/setup"
          component={SetupPage}
          authRoles={['hr', 'admin', 'user', 'manger']}
          userRoles={user?.roles}
          redirectPath={'/webux/my-goals'}
        />
        <GuardedRoute
          path="/webux/enum"
          component={EnumX}
          authRoles={['hr', 'admin']}
          userRoles={user?.roles}
          redirectPath={'/webux/my-goals'}
        />
        <GuardedRoute
          path="/webux/designation"
          component={Designation}
          authRoles={['hr', 'admin']}
          userRoles={user?.roles}
          redirectPath={'/webux/my-goals'}
        />
        <GuardedRoute
          path="/webux/configurations"
          component={Configuration}
          authRoles={['hr', 'admin']}
          userRoles={user?.roles}
          redirectPath={'/webux/my-goals'}
        />
        <GuardedRoute
          path="/webux/email-template"
          component={EmailTemplate}
          authRoles={['hr', 'admin']}
          userRoles={user?.roles}
          redirectPath={'/webux/my-goals'}
        />
        <GuardedRoute
          path="/webux/user-groups"
          component={UserGroupSets}
          authRoles={['hr', 'admin']}
          userRoles={user?.roles}
          redirectPath={'/webux/my-goals'}
        />
        <GuardedRoute
          path="/webux/user-group/:id/:name"
          component={UserGroup}
          authRoles={['hr', 'admin']}
          userRoles={user?.roles}
          redirectPath={'/webux/my-goals'}
        />
      </Switch>
    </Content>
  );
};
